/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  emptyCart: 'emptyCart',
  total: 'total',
  subTotal: 'subTotal',
  taxes: 'taxes',
  discounts: 'discounts',
  ssrPriceSubtotal: 'ssrPriceSubtotal',
  voucher: 'voucher',
  fee: 'fee',
  priceDetails: 'priceDetails',
  close: 'close',
  seats: 'seats',
  numberOfPerson: 'numberOfPerson',
  numberOfPerson_plural: 'numberOfPerson_plural',
  adult: 'adult',
  adult_plural: 'adult_plural',
  child: 'child',
  child_plural: 'child_plural',
  infant: 'infant',
  infant_plural: 'infant_plural',
  participant: 'participant',
  totalPerPerson: 'totalPerPerson',
  promoCodeDiscount: 'promoCodeDiscount',
  airportSurcharge: 'airportSurcharge',
  yourBusStop: 'yourBusStop'
}; export default Keys;